export default __webpack_public_path__ + "static/media/_DSC0747.aa69ab5f.JPG";